/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowPrintColorsQueryResponse, GetShowPrintColorsQueryParams } from "../../models/GetShowPrintColors";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowPrintColorsUrl() {
  const res = { method: 'GET', url: `/api/v1/print-colors` as const }  
  return res
}

/**
 * {@link /api/v1/print-colors}
 */
export async function getShowPrintColors({ params }: { params: GetShowPrintColorsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowPrintColorsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetShowPrintColorsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}